import React from 'react';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';

const TrustpilotRatePopup = (props) => {
    return (
        <SimplePopup text={props.info} popupRef={props.popupRef}>
            <PopupButton href={props.href} target="_blank" iconName="arrow-forward" text={props.buttonTitle} />
        </SimplePopup>
    );
};

export default TrustpilotRatePopup;
